import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as loginActions from './login.actions';
import * as authActions from '../auth/auth.actions';
import { toastr } from 'react-redux-toastr';
import queryString from 'query-string';
import { defaultSsgFormStyle, formElements, SsgFormComponent, ssgFormActions } from '@social-solutions/ssg-forms';
import { formDefinition } from '@social-solutions/ssg-forms-processing';
import { tenantHelpers, integrationTypes } from '../tenantInfo';
import { featureHelpers, features } from '../features';
import "./login-form.scss";

const emailElId = "email-id";
const passwordElId = "password-id";

/** Form component consisting of an email and password, with a login button.
 * The component handles creating a session based on the login credentials and redirects to
 * any routing URL provided in the query string, or else the root page
 */
export class LoginForm extends Component {

  /**
   * Uses the FormState returned by the SsgFormComponent to attempt logging in
   * with the input email and password values. Then redirects or alerts of any errors.
   * @param {formDefinition.FormState} formState
   */
  handleFormSubmit(formState) {
    const { redirect, loginActions, authActions, routing, ssgFormActions } = this.props;
    const { createNewSession } = loginActions || {};
    const { redirectTo, getCurrentSessionFromSecureToken, logoutReset } = authActions || {};
    const { location } = routing || {};
    const { search } = location || {};
    const query = !!search && queryString.parse(search);
    const redirectUrl = !!query && query.redirectUrl;

    ssgFormActions.hardReset("view-demographics");
    ssgFormActions.hardReset("edit-demographics");
    logoutReset();

    // obtain email and password values from the FormState's element response values
    const emailValue = formDefinition.getValue(formState, emailElId);
    const passwordValue = formDefinition.getValue(formState, passwordElId);
    createNewSession(emailValue, passwordValue)
      .then(res => {
        return getCurrentSessionFromSecureToken(res.token)
          .then(() => authActions.fetchParticipantInfo());
      })
      .then(session => {
        if (redirect) {
          var redirectDefault = '/';
          if(tenantHelpers.getIntegrationType() === integrationTypes.apricot && !featureHelpers.featureEnabled(features.apricotPortalTier2)) {
            redirectDefault = '/accountinfo';
          }
          redirectTo(redirectUrl || redirectDefault);
        }
      })
      .catch( err => {
        toastr.error(err.errorCode, err.errorMessage);
        throw(err);
      });
  }

  render() {
    const { login } = this.props;
    const { isFetching: isLoggingIn } = login || {};

    // set unique form elements styles
    var emailStyle = formElements.defaultElementStyles.email;
    emailStyle.group += " login-input-group";
    emailStyle.input += " login-input-tag";
    emailStyle.inputError += " login-input-tag";
    var passwordStyle = formElements.defaultElementStyles.specialText;
    passwordStyle.group += " login-input-group";
    passwordStyle.text += " login-input-tag";
    var formElementStyles = formElements.defaultElementStyles;
    formElementStyles.email = emailStyle;
    formElementStyles.specialText = passwordStyle;

    // set form style
    var formStyle = {
      actions: defaultSsgFormStyle.actions + " login-action-bar",
      primaryButton: defaultSsgFormStyle.primaryButton + " login-form-button",
      title: defaultSsgFormStyle.title += "page-header",
    };

    const emailElement = {
      id: emailElId,
      type: formDefinition.elementTypes.email,
      label: "EMAIL",
      ariaLabel: "Email",
      autoComplete: "off",
    };
    const passwordElement = {
      id: passwordElId,
      type: formDefinition.elementTypes.specialText,
      label: "PASSWORD",
      ariaLabel: "Password",
      isPassword: true,
      textType: formDefinition.specialTextTypes.ANY,
      autoComplete: "off",
    };
    var loginElements = [ emailElement, passwordElement ];

    const loginGroup = {
      id: "login-group-id",
      type: formDefinition.elementTypes.group,
      label: "",
      ariaLabel: "Sign In",
      subElements: loginElements,
      groupType: formDefinition.groupTypes.INDENTED,
    }

    var submitButton = {
      id: "portal-login-btn",
      type: "submit",
      display: "Log In",
      ariaLabel: "Sign In",
      buttonType: "primary",
      functionType: "submit",
      spinnerOn: isLoggingIn,
      spinnerDisplay: "Loading",
      onClick: (state) => this.handleFormSubmit(state)
    };

    // construct a form containing an email and password element, with single login button
    const formProps = {
      id: "login-form-response",
      form: {
        id: "ssg-login-form",
        elements: [ loginGroup ]
      },
      buttonLayout: [ submitButton ],
      elementStyles: formElementStyles,
      css: formStyle
    };

    return (
      <div id="portal-login-form">
        <SsgFormComponent {...formProps} />
      </div>
    );
  }
}

LoginForm.propTypes = {
  loginActions: PropTypes.any.isRequired,
  login: PropTypes.any.isRequired,
  routing: PropTypes.any.isRequired,
  redirect: PropTypes.bool.isRequired
};

const mapStateToProps = ({ routing, login }) => {
  return {
    routing,
    login
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginActions: bindActionCreators(loginActions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
    ssgFormActions: bindActionCreators(ssgFormActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// src/login/login-form.js